<div class="selected-items" *ngIf="selectedLabels.length">
  <div class="selected-item" *ngFor="let label of selectedLabels">{{ label }}</div>
</div>
<a (click)="showPicker()" class="popup-open-button operation ui-btn button-styled">{{ btnTitle }}</a>
